module.exports = __webpack_public_path__ + "static/img/Jack_Darling_desktop.6f3c7d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Darling_desktop.jpg
// module id = nwK0
// module chunks = 0